module.exports = __webpack_public_path__ + "static/A_Web_Programming_1-096f0d1d5670978ec94b72e17f48b0f5.mp4";